import * as React from 'react';
import { LeftAlignRow } from 'components/Styled/Layout.Styled';
import { Col, Row, Button } from 'antd';
import ConfigUtility from 'Core/ConfigUtility';
import { withRouter, RouteComponentProps } from 'react-router';



export interface Props extends RouteComponentProps {
  children?: React.ReactNode;
}

export interface State {}

export class TermsAndConditionsViewWithoutRouter extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {};
    this.goBack = this.goBack.bind(this);
  }

  goBack() {
      this.props.history.goBack();
  }

  render() {
      const config = ConfigUtility.getSync();
      const showBack = this.props.location.state?.internalLinked as boolean || false;
    return (
      <>
        <LeftAlignRow>
          <Col>
            <h2>DELIVERY POLICY</h2>
            <p>
              Delivery of cargo is contingent upon the payment of all relevant charges, production
              of original document and the goods being released by the Jamaica Customs.
            </p>
            <h3>EXPORT RESTRICTIONS</h3>
            <p>
              At this time Kingston Wharves Limited is unable to facilitate the payment of export
              charges over the Internet.
            </p>
            <h2>SECURITY</h2>
            <p>
              Clients who use the Kingston Wharves Limited E- Payment Facility are responsible for
              the security of their user name and/or password. Should they inadvertently let someone
              else know their user name and/or password they should contact Kingston Wharves Limited
              immediately to change their user name and/or password, before any third party damages
              may occur.
            </p>
            <p>
              Credit card fraud and misuse is a growing problem. In the event anyone has access to
              your credit cards and uses them to pay any charges in your name and address, with or
              without your permission, Kingston Wharves will not be liable.
            </p>
            <p>
              Our web site has security measures in place to protect against the loss, misuse, and
              alteration of the information under our control. Only certain employees have access to
              the information you provide us. The Certification Authority Verisign, also certifies
              this site; our customers communicate securely using the Secure Sockets Layer (SSL -
              128bit) technology, the standard for secure communications on the Web.
            </p>
            <p>
              Kingston Wharves will not be responsible for any business lost (including loss of
              profits, revenue, contracts, anticipated savings, data, goodwill or wasted
              expenditure) or any other indirect or consequential loss that is not reasonably
              foreseeable.
            </p>
            <h2>REFUND RETURN &amp; CANCELLATION POLICY</h2>
            <p>
              The Customer Service Manager will review all requests for refunds or cancellations, on
              a case-by-case basis and funds will be returned via the medium in which it was
              received. If you have any questions about the privacy statement or refund policy, the
              practices of this application, or your dealings with the application, you may contact:
            </p>
          </Col>
        </LeftAlignRow>
        <Row>
          <Col>
            <LeftAlignRow>
              <Col>
                <h3>Customer Service Manager</h3>
              </Col>
            </LeftAlignRow>
            <LeftAlignRow>
                <Col>{config?.Contact.Address}</Col>
            </LeftAlignRow>
            <LeftAlignRow>
                <Col>Telephone: {config?.Contact.Telephone}</Col>
            </LeftAlignRow>
            <LeftAlignRow>
                <Col>Fax: {config?.Contact.Fax}</Col>
            </LeftAlignRow>
            <LeftAlignRow>
                <Col>email: {config?.Contact.Email}</Col>
            </LeftAlignRow>
          </Col>
        </Row>
        <LeftAlignRow>
            <Col>
                <p>KWL will respond to customer service queries within two business days.</p>
            </Col>
        </LeftAlignRow>
        {showBack && <Row>
            <Col>
                <Button type='primary' onClick={this.goBack}>Back</Button>
            </Col>
        </Row>}
      </>
    );
  }
}

const TermsAndConditionsView = withRouter(TermsAndConditionsViewWithoutRouter);
export default TermsAndConditionsView;